<div>
  <!-- <ngb-datepicker
    *ngIf="currentMode === 'MONTH'"
    #dp="ngbDatepicker"
    name="datepicker"
    [showWeekNumbers]="true"
    (dateSelect)="setCurrentDay($event)" >

  </ngb-datepicker> -->
  <div class="container">
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center">
        <div *ngIf="currentMode === 'DAY'" class="mr-2">
          <div class="btn-group">
            <button class="btn btn-primary" (click)="goBack()">
              <sb-icon class="icon-in-btn" icon="chevronLeft"></sb-icon>
            </button>
          </div>
        </div>
        <div class="d-flex align-items-center">
          <h4>
            {{getTitle()}}
          </h4>
        </div>
      </div>
      <ng-container *ngIf="currentMode === 'MONTH'">
        <div class="d-flex tr justify-content-end mb-2">
          <div class="btn-group">
            <button class="btn btn-primary" (click)="decMonth()">
              <sb-icon class="icon-in-btn" icon="chevronLeft"></sb-icon>
            </button>
            <!--  old comment <label class="btn datelabel" ngbButtonLabel>{{getCurrentMonthName()}}</label> -->
            <button class="btn btn-primary" (click)="incMonth()">
              <sb-icon class="icon-in-btn" icon="chevronRight"></sb-icon>
            </button>
          </div>
        </div>
      </ng-container>
    </div>
    <ng-container *ngIf="currentMode === 'MONTH'">
      <div class="d-flex flex-row weekdays">
        <div class="col d-flex p-0 align-item-center justify-content-center weekdayheader" *ngFor="let weekday of weekdays"
             style="overflow: hidden; font-size: 10px;">
          <p>
            <b>{{weekday}}</b>
          </p>
        </div>
      </div>
      <div class="d-flex flex-row week" *ngFor="let row of rows">
        <div class=" col d-flex p-0 align-item-center justify-content-center day-of-month" [ngClass]="getClasses(col)"
             *ngFor="let col of row" (click)="setCurrentDay(col)">
          <p>
            {{col.day}}
          </p>
        </div>
      </div>
    </ng-container>
  </div>

  <sb-calendar-day *ngIf="currentMode === 'DAY'" [currentDay]="currentDay" (changeCurrentDay)="currentDay = $event"
                   [dateTimeRanges]="dateTimeRanges"></sb-calendar-day>

</div>
